import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="slide"
// Replaces custom_slide() function with Stimulus controller
// Handles various slide toggle behaviors for review pages
export default class extends Controller {
  static values = {
    type: { type: String, default: "opener" }, // opener, todo-toggle, img-top1, img-top1-alt, ans-opener, que-opener
    itemdata: String,
    target: String,
    slideSpeed: { type: Number, default: 100 }
  }

  connect() {
    // Initialize: hide td ul elements and .open-block elements on page load
    this.initializePage()
  }

  initializePage() {
    // Hide all td ul elements (matching original behavior)
    const tdUlElements = this.element.querySelectorAll('td ul')
    tdUlElements.forEach(el => {
      if (window.jQuery) {
        window.$(el).hide()
      } else {
        el.style.display = 'none'
      }
    })

    // Hide all .open-block elements
    const openBlocks = this.element.querySelectorAll('.open-block')
    openBlocks.forEach(el => {
      if (window.jQuery) {
        window.$(el).hide()
      } else {
        el.style.display = 'none'
      }
    })
  }

  toggle(event) {
    event.preventDefault()

    // Get the clicked element (the element with data-action, not the controller element)
    const clickedElement = event.currentTarget

    if (clickedElement.classList.contains('opener')) {
      this.handleOpener(clickedElement)
    } else if (clickedElement.classList.contains('to-do-toggle')) {
      this.handleTodoToggle(clickedElement)
    } else if (clickedElement.classList.contains('img_top1')) {
      this.handleImgTop1(clickedElement)
    } else if (clickedElement.classList.contains('img-top1')) {
      this.handleImgTop1Alt(clickedElement)
    } else if (clickedElement.classList.contains('ans-opener') && clickedElement.closest('td.ans')) {
      this.handleAnsOpener(clickedElement)
    } else if (clickedElement.classList.contains('ans-opener') && clickedElement.closest('td.que')) {
      this.handleQueOpener(clickedElement)
    }
  }

  // Handle .opener click - toggles #alphabets_{itemdata}
  handleOpener(element) {
    const itemdata = element.getAttribute('itemdata')
    if (!itemdata) return

    const targetElement = document.getElementById(`alphabets_${itemdata}`)
    if (!targetElement) return

    // Toggle the element
    if (window.jQuery) {
      window.$(targetElement).slideToggle(100)
    } else {
      this.slideToggle(targetElement, 100)
    }

    // Toggle text between "Show Answer" and "Hide Answer"
    const currentText = element.textContent.trim()
    element.textContent = currentText === 'Show Answer' ? 'Hide Answer' : 'Show Answer'

    // Toggle class
    element.classList.toggle('toggler-pad')
  }

  // Handle .to-do-toggle click - toggles #open-block{target}
  handleTodoToggle(element) {
    const target = element.getAttribute('target')
    if (!target) return

    const targetElement = document.getElementById(`open-block${target}`)
    if (targetElement) {
      if (window.jQuery) {
        window.$(targetElement).slideToggle(300)
      } else {
        this.slideToggle(targetElement, 300)
      }
    }

    // Toggle all .to-do-toggle i icons
    const icons = document.querySelectorAll('.to-do-toggle i')
    icons.forEach(icon => {
      if (window.jQuery) {
        window.$(icon).toggle()
      } else {
        icon.style.display = icon.style.display === 'none' ? '' : 'none'
      }
    })
  }

  // Handle .img_top1 click
  handleImgTop1(element) {
    const itemdata = element.getAttribute('itemdata')
    if (!itemdata) return

    const hideSection = document.getElementById(`hide-section_${itemdata}`)
    const ansOpener = document.getElementById(`ans-opener_${itemdata}`)
    const tr = document.getElementById(`tr_${itemdata}`)

    if (hideSection) {
      // Always add top-align class to td elements
      if (tr) {
        const tds = tr.querySelectorAll('td')
        tds.forEach(td => td.classList.add('top-align'))
      }

      // Toggle hide section
      if (window.jQuery) {
        window.$(hideSection).slideToggle(400)
      } else {
        this.slideToggle(hideSection, 400)
      }
    }

    // Toggle all icons (chevron-down and chevron-up) to create rotation effect
    // element is the img_top1 td itself, so we can use it directly
    const icons = element.querySelectorAll('i')
    icons.forEach(icon => {
      if (window.jQuery) {
        window.$(icon).toggle()
      } else {
        icon.style.display = icon.style.display === 'none' ? '' : 'none'
      }
    })

    // Update ans-opener text
    if (ansOpener) {
      const currentText = ansOpener.textContent.trim()
      ansOpener.textContent = currentText === 'Show Question' ? 'Hide Question' : 'Show Question'
    }
  }

  // Handle .img-top1 click (different from img_top1)
  handleImgTop1Alt(element) {
    const itemdata = element.getAttribute('itemdata')
    if (!itemdata) return

    const hideSection = document.getElementById(`hide-section_${itemdata}`)
    const answerShowed = document.getElementById(`answer-showed_${itemdata}`)
    const imgTop = document.getElementById(`img_top_${itemdata}`)

    if (hideSection) {
      if (window.jQuery) {
        window.$(hideSection).slideToggle()
      } else {
        this.slideToggle(hideSection)
      }
    }

    if (answerShowed) {
      if (window.jQuery) {
        window.$(answerShowed).slideToggle(500)
      } else {
        this.slideToggle(answerShowed, 500)
      }
    }

    // Toggle all icons (chevron-down and chevron-up) to create rotation effect
    if (imgTop) {
      const icons = imgTop.querySelectorAll('i')
      icons.forEach(icon => {
        if (window.jQuery) {
          window.$(icon).toggle()
        } else {
          icon.style.display = icon.style.display === 'none' ? '' : 'none'
        }
      })
    }
  }

  // Handle td.ans .ans-opener click
  handleAnsOpener(element) {
    const itemdata = element.getAttribute('itemdata')
    if (!itemdata) return

    const hideSection = document.getElementById(`hide-section_${itemdata}`)
    const imgTop = document.getElementById(`img_top_${itemdata}`)
    const tr = document.getElementById(`tr_${itemdata}`)

    if (hideSection) {
      // Always add top-align class to td elements
      if (tr) {
        const tds = tr.querySelectorAll('td')
        tds.forEach(td => td.classList.add('top-align'))
      }

      // Toggle hide section
      if (window.jQuery) {
        window.$(hideSection).slideToggle(400)
      } else {
        this.slideToggle(hideSection, 400)
      }
    }

    // Toggle text
    const currentText = element.textContent.trim()
    element.textContent = currentText === 'Show Question' ? 'Hide Question' : 'Show Question'

    // Toggle all icons (chevron-down and chevron-up) to create rotation effect
    if (imgTop) {
      const icons = imgTop.querySelectorAll('i')
      icons.forEach(icon => {
        if (window.jQuery) {
          window.$(icon).toggle()
        } else {
          icon.style.display = icon.style.display === 'none' ? '' : 'none'
        }
      })
    }
  }

  // Handle td.que .ans-opener click
  handleQueOpener(element) {
    const itemdata = element.getAttribute('itemdata')
    if (!itemdata) return

    const hideSection = document.getElementById(`hide-section_${itemdata}`)
    const answerShowed = document.getElementById(`answer-showed_${itemdata}`)
    const imgTop = document.getElementById(`img_top_${itemdata}`)

    if (hideSection) {
      if (window.jQuery) {
        window.$(hideSection).slideToggle()
      } else {
        this.slideToggle(hideSection)
      }
    }

    if (answerShowed) {
      if (window.jQuery) {
        window.$(answerShowed).slideToggle(500)
      } else {
        this.slideToggle(answerShowed, 500)
      }
    }

    // Toggle all icons (chevron-down and chevron-up) to create rotation effect
    if (imgTop) {
      const icons = imgTop.querySelectorAll('i')
      icons.forEach(icon => {
        if (window.jQuery) {
          window.$(icon).toggle()
        } else {
          icon.style.display = icon.style.display === 'none' ? '' : 'none'
        }
      })
    }
  }

  // Fallback slideToggle implementation if jQuery is not available
  slideToggle(element, duration = 300) {
    if (element.style.display === 'none' || !element.style.display) {
      // Show
      element.style.display = 'block'
      element.style.height = '0'
      element.style.overflow = 'hidden'
      element.style.transition = `height ${duration}ms ease`

      const height = element.scrollHeight
      element.style.height = `${height}px`

      setTimeout(() => {
        element.style.height = ''
        element.style.overflow = ''
        element.style.transition = ''
      }, duration)
    } else {
      // Hide
      element.style.height = `${element.scrollHeight}px`
      element.style.overflow = 'hidden'
      element.style.transition = `height ${duration}ms ease`

      setTimeout(() => {
        element.style.height = '0'
      }, 10)

      setTimeout(() => {
        element.style.display = 'none'
        element.style.height = ''
        element.style.overflow = ''
        element.style.transition = ''
      }, duration)
    }
  }
}
